import { useEffect, useState} from 'react'
import { db } from "../firebase/config"

import { doc, onSnapshot} from "firebase/firestore"; 

export const useDocument = (collections, id) => {
    const[document, setDocument] = useState(null)
    const[error, setError] = useState(null)
   

    //realtime data for document
    useEffect(() => {
       const ref = doc(db,collections,id)
       const unsub = onSnapshot(ref, (snapshot) => {
           if (snapshot.data()) {
            setDocument({...snapshot.data(),id: snapshot.id})
            setError(null)
           }else{
               setError('No such document exists')
           }
         
        },error => {
            setError('Couldnot fetch data')
            console.log(error.message)
        })

        return () => unsub()
    },[collections, id])
    return {document, error}
}